import { lazy } from "react";
import { Route, Routes } from "react-router-dom";

import SuspensedView from "@/components/SuspensedView";

const AuthPage = lazy(() => import("@/pages/AuthPage"));
  
const AuthRouter = () => {
  return (
    <Routes>
      <Route
        path="login"
        element={
          <SuspensedView>
            <AuthPage />
          </SuspensedView>
        }
      />
    </Routes>
  );
};

export default AuthRouter;
